@if (!loading()) {
  <div class="questions-table">
    <div class="header">
      <span>Field</span>
      <span>Featured</span>
      <span>Required</span>
    </div>
    @for (group of groups(); track group.title) {
      <mat-expansion-panel class="custom-expansion-panel" expanded>
        <mat-expansion-panel-header>
          <mat-panel-title class="custom-expansion-title"> {{ group.title }} </mat-panel-title>
        </mat-expansion-panel-header>
        @for (field of group.children; track field.title) {
          <div class="badging-field-question">
            <div class="badging-name">
              <mat-checkbox [(ngModel)]="field.active" (ngModelChange)="sendQuestion()">{{ field.title }}</mat-checkbox>
            </div>
            @if (field.isFeatured) {
              <mat-checkbox [(ngModel)]="field.featured" (ngModelChange)="sendQuestion()"></mat-checkbox>
            }
            <mat-checkbox
              [(ngModel)]="field.required"
              (ngModelChange)="sendQuestion()"
              [disabled]="isQuestionTypeProfile(field)"
            ></mat-checkbox>
          </div>
        }
      </mat-expansion-panel>
    }
  </div>
} @else {
  <div class="flex w-full justify-center">
    <app-loading />
  </div>
}
